// extracted by mini-css-extract-plugin
export default {"container":"MarkdownLastEditedBy-module__container--fKxHN","content":"MarkdownLastEditedBy-module__content--rtYcU"};